import React, { useEffect } from "react";
import NoData from "../../../asset/images/No data available.svg";
import upArrow from "../../../asset/images/up-arrow.svg";
import downArrow from "../../../asset/images/down-arrow-red.svg";
import Loader from "../../Common/Loader";
import {
  // aboveOneLacs,
  forToFix,
  // numDifferentiation,
  numDifferentiationWithoutSymbol,
  // numberFormat,
  // numDifferentiation,
} from "../../../CommonMethhods/CovertRupees";
// import Highcharts from "highcharts";
// import HighchartsReact from "highcharts-react-official";
// import { Constants } from "../../../CommonMethhods/Constants";

function Snapshot(props) {
  const title = props.title;
  const dataTarget = props.dataTarget;
  const snapshotData = props.snapshotData;
  const snapshotOverall = snapshotData.overall;
  const snapshotDiffValue = snapshotData.diff;
  const snapshotDiffPercentage = snapshotData.diffper;

  const ChartEq = props.chartEq;
  const ChartFno = props.chartFno;
  const ChartTotal = props.chartTotal;
  const forChartEqPercent = (ChartEq / ChartTotal) * 100;
  const forChartFnoPercent = (ChartFno / ChartTotal) * 100;
  let Overall;
  let DiffValue;

  const loader = props.loader;
  const overall =
    title === "Client Snapshot"
      ? "Newly Acquired Clients"
      : "Overall " + title.split(" ")[0];

  const time = props.businessFilter;

  const duration = time.split("l")[0];

  if (props.isActive === true) {
    {
      Overall =
        snapshotOverall === undefined || null
          ? "0"
          : numDifferentiationWithoutSymbol(snapshotOverall);
      DiffValue =
        snapshotDiffValue === undefined || null
          ? "0"
          : numDifferentiationWithoutSymbol(snapshotDiffValue);
    }
  } else {
    Overall = snapshotOverall === undefined || null ? "0" : snapshotOverall;
    DiffValue =
      snapshotDiffValue === undefined || null ? "0" : snapshotDiffValue;
  }

  const showSnaphotData = () => {
    return (
      <>
        <div className="block1-data">
          <div className="block1-data-display">
            {/* snapshot overall value */}
            <h2>{Overall}</h2>
            <div className="overall-snap-value">
              <h3
                className={
                  snapshotDiffValue === 0
                    ? "text-muted"
                    : snapshotDiffValue < 0
                    ? "red-txt"
                    : "green-txt"
                }
              >
                {snapshotDiffValue === 0 ? null : snapshotDiffValue < 0 ? (
                  <img src={downArrow} alt="Down Arrow" />
                ) : (
                  <img src={upArrow} alt="Up Arrow" />
                )}

                {/* snapshot difference value */}
                <b>{DiffValue}</b>
              </h3>
              <h3
                className={
                  snapshotDiffPercentage === 0
                    ? "text-muted"
                    : snapshotDiffPercentage < 0
                    ? "red-txt"
                    : "green-txt"
                }
              >
                (
                {snapshotDiffPercentage === undefined || null
                  ? "0"
                  : forToFix(snapshotDiffPercentage) + "%"}
                )
              </h3>
            </div>

            {/* snapshot difference value */}

            <h4>{overall}</h4>
          </div>

          <p>
            {props.textfield} {duration}
          </p>
        </div>
      </>
    );
  };
  return (
    <>
      <div className="col-md-6 col-lg-3">
        <div className="block1">
          <div className="card-subtitle" id="flush-headingOne">
            <h3>{title}</h3>
            {/* add button to open snaphot table  + -  */}
            <div
              className="accordion-button toggle-btn"
              type="button"
              data-toggle="collapse"
              data-target={dataTarget}
              aria-expanded="false"
              aria-controls="flush-collapseOne"
              // onClick={handleSnaphotTable}
            ></div>
          </div>
          {loader ? (
            <div className="loader-alignment">
              <Loader />
            </div>
          ) : (
            showSnaphotData()
          )}
        </div>
      </div>
    </>
  );
}

export default Snapshot;
